import React from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  { q: 'How quickly can I set up?', a: 'It takes just minutes, with no coding required.' },
  { q: 'Will my customers use online booking?', a: 'Yes! Nearly all customers prefer booking on the phone' },
  { q: 'Is my data secure?', a: 'Absolutely. Sparki uses secure AWS cloud services.' },
];

const FAQ: React.FC = () => (
  <section className="container section animate-fadeInUp">
    <h2>Common questions</h2>
    {faqs.map((f, i) => (
      <div key={i}>
        <h3 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>{f.q}</h3>
        <p>{f.a}</p>
      </div>
    ))}
    <div className="section-cta">
          <Link to="/get-started" className="cta">Get started for free</Link>
        </div>
  </section>
);

export default FAQ;
